'use client';

import { useToastBus } from '@/hooks/useToastBus';

/** Mount once at app level — subscribes to all toast events */
export function ToastBusProvider() {
  useToastBus();
  return null;
}
